<template>
	<div class="events-container">
		<div class="row">
			<div id="events-main" class="col-md-8 events-main">
				<eventsPagination />
				<eventsList />
			</div>
			<div id="events-sidebar" class="col-md-4 events-sidebar">
				<eventsCalendar />
			</div>
		</div>
	</div>
</template>

<script>
// import { store } from "./_juicebox-store.js";
import { mapActions } from "vuex";
// import moment from "moment";
import eventsList from "./events-list.vue";
// import eventsSpan from "./events-span.vue";
import eventsCalendar from "./events-calendar.vue";
import eventsPagination from "./events-pagination.vue";

export default {
	name: "Events",
	data() {
		return {
			data: this.$store.state
		};
	},
	components: {
		// eventsSpan,
		eventsList,
		eventsPagination,
		eventsCalendar
	},
	methods: {
		...mapActions(["loadEvents"])
		// getEvents: function() {
		// 	// Get our current events.
		// 	let currentEvents = this.data.events;

		// 	// API call for 1 month before, 1 month after current date span.
		// 	// let beforeDate = moment
		// 	// 	.unix(this.data.currentDate[0])
		// 	// 	.clone()
		// 	// 	.subtract(1, this.data.timeSpan)
		// 	// 	.unix();
		// 	// let afterDate = moment
		// 	// 	.unix(this.data.currentDate[1])
		// 	// 	.clone()
		// 	// 	.add(1, this.data.timeSpan)
		// 	// 	.unix();
		// }
	},
	mounted: function() {
		// this.getEvents();
	}
};
</script>